import React from 'react';
import { IconButton, CircularProgress, Tooltip } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

/**
 * Botón de descarga reutilizable con indicador de progreso
 * 
 * @param {Object} props
 * @param {Function} props.onDownload - Función para manejar la descarga
 * @param {boolean} props.isDownloading - Estado que indica si se está descargando
 * @param {string} props.fileType - Tipo de archivo (imagen, video, documento, etc.)
 * @param {Object} props.sx - Estilos adicionales para el botón
 * @param {string} props.size - Tamaño del botón (small, medium, large)
 * @param {number} props.progressSize - Tamaño del indicador de progreso
 */
const DownloadButton = ({ 
    onDownload, 
    isDownloading = false, 
    fileType = 'archivo',
    sx = {},
    size = 'small',
    progressSize = 16,
}) => {
    return (
        <Tooltip title={isDownloading ? `Descargando...` : `Descargar ${fileType}`}>
            <IconButton
                size={size}
                onClick={onDownload}
                disabled={isDownloading}
                sx={{
                    backgroundColor: 'rgba(0,0,0,0.3)',
                    color: 'white',
                    '&:hover': {
                        backgroundColor: 'rgba(0,0,0,0.5)',
                    },
                    ...sx
                }}
            >
                {isDownloading ? (
                    <CircularProgress size={progressSize} color="primary" />
                ) : (
                    <FileDownloadIcon fontSize={size === 'small' ? 'small' : 'medium'} />
                )}
            </IconButton>
        </Tooltip>
    );
};

export default DownloadButton;